import { render, staticRenderFns } from "./AwardTypes.vue?vue&type=template&id=0d235a25"
import script from "./AwardTypes.vue?vue&type=script&lang=js"
export * from "./AwardTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports